import React, { PropsWithChildren } from 'react'

export const GridFields = ({children , label}:Props) => {
    return (
        <div className='mt-6'>
            <label className='flex items-center font-semibold'>
             {label}
            </label>
            <div className='grid grid-cols-3 mt-3'>
                <div className='col-span-2'>
                <div className='grid grid-cols-3 gap-x-4'>
                   {children}
                </div>
                </div>
            </div>
        </div>
    )
}

interface Props extends PropsWithChildren<any>{
    label?:string,
}
